// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3Ag9n","header":"MergedInvoice_header__1D0mP"};